import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GameButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/gieliguessr-transparent-banner--t3chat--1.png");
